import * as React from 'react';
import { Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import './style.scss';

const CardCarousel = props => {
  return (
    <div className="card-carousel">
      <Swiper
        modules={[Pagination, A11y]}
        slideToClickedSlide
        centeredSlides
        loop
        pagination={{ clickable: true }}
        loopedSlides={3}
        grabCursor
        autoHeight
      >
        {props.children.map((card, i) => (
          <SwiperSlide key={i}>{card}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CardCarousel;
